import script from "./MediaForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaForm.vue?vue&type=script&lang=ts&setup=true"

import "./MediaForm.vue?vue&type=style&index=0&id=f2536f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2536f98"]])

export default __exports__